/* Customize this piece: shows the name's dependent fields only once there is a name, and the enamel color only for an
   enamel finish. Hidden selects are disabled so they are not posted; with no script every field is shown and a blank
   choice posts nothing. The personalized note shows once anything is entered. Blank fields are left out of the post on submit (no-script: a blank
   field posts as a blank property). */
(function () {
  document.querySelectorAll('[data-djh-pz]').forEach(function (root) {
    var name = root.querySelector('[data-pz-name]');
    var inside = root.querySelector('[data-pz-inside]');
    var finish = root.querySelector('[data-pz-finish]');
    var enamel = root.querySelector('[data-pz-enamel]');
    var chevron = root.querySelector('[data-pz-chevron]');
    var note = root.querySelector('[data-pz-note]');
    var needs = root.querySelectorAll('[data-pz-needs-name]');
    if (!name || !inside || !finish || !enamel || !note) return;

    function show(el, on) {
      el.hidden = !on;
      el.querySelectorAll('select').forEach(function (s) { s.disabled = !on; });
    }

    function sync() {
      var hasName = name.value.trim().length > 0;
      needs.forEach(function (el) { show(el, hasName); });
      // A name starts on the first chevron style (Standard) and on raised lettering; the customer can change either.
      if (hasName && chevron && !chevron.value && chevron.options.length > 1) chevron.value = chevron.options[1].value;
      if (hasName && !finish.value && finish.options.length > 1) finish.value = finish.options[1].value;
      show(enamel, hasName && /enamel/i.test(finish.value));
      note.hidden = !(hasName || inside.value.trim().length > 0);
    }

    // HARD STOP, D-357 (Henry, 2026-10-24): a pendant's name holds no more letters than its bar carries; spaces count.
    // The server counts again and is the authority, so this is a courtesy that keeps the page honest.
    var counter = root.querySelector('[data-pz-count]');
    var rule = (root.getAttribute('data-pz-rule') || '').split(';').map(function (line) {
      var p = line.split('|').map(function (s) { return s.trim(); });
      return { orientation: p[0], inches: parseFloat(p[1]), max: parseInt(p[2], 10) };
    }).filter(function (r) { return isFinite(r.inches) && isFinite(r.max); });
    var orientation = root.getAttribute('data-pz-orientation') || '';
    var lengthIn = parseFloat(root.getAttribute('data-pz-length'));
    var stopped = false;
    var lengthChoice = root.getAttribute('data-pz-length-choice') === 'true';

    function cap() {
      if (!counter || !rule.length) return null;
      var rows = rule.filter(function (r) { return !orientation || r.orientation === orientation; });
      if (!rows.length) rows = rule;
      rows.sort(function (a, b) { return a.inches - b.inches; });
      var top = rows[rows.length - 1];
      if (!isFinite(lengthIn)) return { max: top.max, inches: null, top: true };
      var hit = null;
      rows.forEach(function (r) { if (r.inches <= lengthIn) hit = r; });
      hit = hit || rows[0];
      return { max: hit.max, inches: hit.inches, top: hit === top };
    }

    function fill(text, c) {
      return text.replace('[n]', String(Array.from(name.value.normalize('NFC')).length)).replace('[max]', String(c.max))
        .replace('[len]', c.inches === null ? 'this length' : String(c.inches) + ' in');
    }

    var rejected = root.querySelector('[data-pz-rejected]');
    var rejectedTimer;
    var ENGRAVABLE_CHAR = /^[A-Za-z\u00c0-\u00ff\u0100-\u017f\u02bb\u02bc\u2018\u2019'\-. ]$/;
    // The workshop cuts letters (with their marks), the okina, apostrophes, hyphen, period and space; the server holds the same set.
    function keepEngravable() {
      if (!rejected) return;
      var chars = Array.from(name.value.normalize('NFC'));
      var bad = chars.filter(function (ch) { return !ENGRAVABLE_CHAR.test(ch); });
      if (bad.length) name.value = chars.filter(function (ch) { return ENGRAVABLE_CHAR.test(ch); }).join('');
      // The sentence stays up for a few seconds, so the next keystroke does not take it away before it is read.
      if (!bad.length) return;
      rejected.hidden = false;
      rejected.textContent = (rejected.getAttribute('data-pz-rejected-text') || '').replace('[chars]', Array.from(new Set(bad)).map(function (ch) { return '\u201c' + ch + '\u201d'; }).join(' '));
      window.clearTimeout(rejectedTimer);
      rejectedTimer = window.setTimeout(function () { rejected.hidden = true; rejected.textContent = ''; }, 6000);
    }

    // `cut` is true while the customer types (the field holds to the bar). A change of Length never cuts what was typed: a name
    // that no longer fits is kept, said so in a sentence, and held out of Add to cart until it fits or a longer length is chosen.
    function hold(cut) {
      keepEngravable();
      var c = cap();
      if (!c) return;
      var chars = Array.from(name.value.normalize('NFC'));
      var over = chars.length > c.max;
      if (over && cut) { name.value = chars.slice(0, c.max).join(''); stopped = true; over = false; }
      var n = Array.from(name.value.normalize('NFC')).length;
      if (n < c.max) stopped = false;
      name.setCustomValidity('');
      if (over) {
        var sentence = fill(root.getAttribute('data-pz-over-text') || '', c);
        counter.textContent = sentence;
        name.setCustomValidity(sentence);
      } else if (stopped && n >= c.max) {
        counter.textContent = fill(root.getAttribute(c.top || !lengthChoice ? 'data-pz-stop-top-text' : 'data-pz-stop-text') || '', c);
      } else {
        counter.textContent = n ? fill(root.getAttribute('data-pz-count-text') || '', c) : '';
      }
    }

    // The Length option can change with the variant; the product page announces it.
    var section = root.closest('[data-djh-product]') || document;
    section.addEventListener('djh:variant-change', function (e) {
      var d = e.detail || {};
      var i = (d.names || []).indexOf('Length');
      if (i === -1 || !d.options || d.options[i] == null) return;
      var v = parseFloat(String(d.options[i]).replace(/\s*in$/i, ''));
      if (isFinite(v)) { lengthIn = v; stopped = false; hold(false); }
    });

    ['input', 'change'].forEach(function (evt) { root.addEventListener(evt, function () { hold(true); sync(); }); });
    hold(true);
    sync();

    // Shopify keeps a blank property as a blank line on the cart and the order, so a field nobody filled is left out of the post.
    var form = root.closest('form');
    if (form) {
      form.addEventListener('submit', function () {
        var blanks = [];
        root.querySelectorAll('input, select, textarea').forEach(function (el) {
          if (!el.disabled && el.name && el.name.indexOf('properties[') === 0 && !el.value.trim()) { el.disabled = true; blanks.push(el); }
        });
        // The form data is read as the event ends; give the fields back so a back-navigation restores a usable form.
        setTimeout(function () { blanks.forEach(function (el) { el.disabled = false; }); }, 0);
      }, true);
    }
  });
})();
